import React, { useState, useEffect } from "react";
import {
  Card,
  CardHeader,
  Table,
  Container,
  Row,
  Col,
  InputGroup,
  Input,
  Button,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Modal, ModalHeader, ModalBody, ModalFooter,
  Spinner,
  Badge
} from "reactstrap";
import { getOffers } from "service/offer.service";
import { FaPencil, FaTrashCan,FaPlay, FaPause  } from "react-icons/fa6";
import { Link } from "react-router-dom";
import { updateOffer } from "service/offer.service";
import { getOfferStatus } from "service/offerstatus.service";
import { getOffersFiltered } from "service/offer.service";

const ViewCampaign = () => {
  const [searchValue, setSearchValue] = useState("");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedSortColumn, setSelectedSortColumn] = useState(null);
  const [sortDirection, setSortDirection] = useState("asc");
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [expandedRow, setExpandedRow] = useState(null);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
const [deleteItemId, setDeleteItemId] = useState(null);
const [isLoading, setIsLoading] = useState(false);
const [notification, setNotification] = useState(null);
const [offerStatuses, setOfferStatuses] = useState([
  { value: 'live', label: 'Live' },
  { value: 'paused', label: 'Paused' },
]);
const [selectedStatus, setSelectedStatus] = useState(
  Array(data.length).fill("Live")
);
const [dropdownStatusOpen, setDropdownStatusOpen] = useState(
  Array(data.length).fill(false)
);
const [offerStatusFilter, setOfferStatusFilter] = useState("all");
const [offerStatusFilterOpen, setOfferStatusFilterOpen] = useState(false);

  useEffect(() => {
    // Fetch data from an API or a data source
    // and update the "data" state with the received data
    // For example:
    const fetchData = async () => {
      try {
        // Fetch data from the API
        const data = await  getOffers ();
      
        setData(data.data.taskPeFeed.rows);
        if(data.data.taskPeFeed.rows.length > 0){
          
            const updatedStatus = [...selectedStatus];
          for (let i = 0; i <data.data.taskPeFeed.rows.length; i++) {
           
           
            updatedStatus[i] = data.data.taskPeFeed.rows[i].status;
          
        
            
        }
        setSelectedStatus(updatedStatus);
        // renderBadge(i);

        }
         
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
    fetchOfferStatus();
  }, []);

  const fetchOfferStatus = async () => {
    try {
        const offertype = await getOfferStatus();
        console.log(offertype);
        setOfferStatuses(offertype.data.offerStatusFeed);
    } catch (error) {
        console.error('Error fetching advertisers:', error);
    }
};
  const handleRowClick = (rowId) => {
    if (expandedRow === rowId) {
      // If the clicked row is already expanded, collapse it
      setExpandedRow(null);
    } else {
      // Otherwise, expand the clicked row
      setExpandedRow(rowId);
    }
  };

  // Filtering the data based on search value
  const filteredData = data.filter((item) =>
    item.offer_name.toLowerCase().includes(searchValue.toLowerCase())
  );

  // Sorting the data based on the selected column and sort direction
  const sortedData = selectedSortColumn
    ? filteredData.sort((a, b) => {
        const columnA = a[selectedSortColumn];
        const columnB = b[selectedSortColumn];

        if (columnA < columnB) {
          return sortDirection === "asc" ? -1 : 1;
        }
        if (columnA > columnB) {
          return sortDirection === "asc" ? 1 : -1;
        }
        return 0;
      })
    : filteredData;

  // Pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = sortedData.slice(indexOfFirstItem, indexOfLastItem);

  // Handle search input change
  const handleSearchChange = (e) => {
    setSearchValue(e.target.value);
  };

  const openDeleteModal = (itemId) => {
    setDeleteItemId(itemId);
    setIsDeleteModalOpen(true);
  };
  
  const closeDeleteModal = () => {
    setIsDeleteModalOpen(false);
    setDeleteItemId(null);
  };



  const handleDelete = () => {
    // Perform the delete action here using the deleteItemId state variable
    console.log("Deleting item with ID:", deleteItemId);
  
    // Close the modal after deleting the item
    closeDeleteModal();
  };

  const updateOfferStatus = async(offerId, status) => {
    setIsLoading(true);
    const data = await  updateOffer(offerId, {status: status});


    console.log(data);
    if(data){
      fetchOffersData();
      setNotification({ type: "success", message: "Offer Status Updated" });
      setIsLoading(false);
    }else{
      setNotification({ type: "error", message: "Unable to update offer status" });
    }

    setTimeout(() => {
      setNotification(null);
    }, 3000);  

  }


  const fetchOffersData = async () => {
    try {
      // Fetch data from the API
      const data = await  getOffers();
    
      setData(data.data.taskPeFeed.rows);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  
  
  // Handle column sort
  const handleSort = (columnName) => {
    if (selectedSortColumn === columnName) {
      setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    } else {
      setSelectedSortColumn(columnName);
      setSortDirection("asc");
    }
  };

  // Handle page change
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);

  };

  // Handle items per page change
  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(parseInt(e.target.value));
    setCurrentPage(1); // Reset current page to the first page
  };

  const handleStatusChange = (status, index) => {
    console.log(status, index);
  
    const updatedStatus = [...selectedStatus];
    updatedStatus[index] = status;
    setSelectedStatus(updatedStatus);

    console.log(selectedStatus);

    updateOfferStatus(currentItems[index].id,status);

  };
  const handleFilteredStatusChange = (status) => {
    
    setOfferStatusFilter(status);
   
    fetchFilteredOffersData(status);

  };


  const fetchFilteredOffersData = async (status) => {
    try {
        let query = {
            status: status
        }
        if(status === "all"){
            query = {}
        }
        const data = await  getOffersFiltered(query);
      
        setData(data.data.taskPeFeed.rows);
        if(data.data.taskPeFeed.rows.length > 0){
          
          const updatedStatus = [...selectedStatus];
        for (let i = 0; i <data.data.taskPeFeed.rows.length; i++) {
         
         
          updatedStatus[i] = data.data.taskPeFeed.rows[i].status;
        
      
          
      }
      setSelectedStatus(updatedStatus);

        }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };


  const renderBadge = (index) => {
    let color = "";
    console.log(selectedStatus);
    switch (selectedStatus[index]) {
      case "live":
        color = "bg-gradient-success";
        break;
      case "paused":
        color = "bg-gradient-warning";
        break;
      case "removed":
        color = "bg-gradient-danger";
        break;
      default:
        color = "bg-gradient-info";
        break;
    }

    return <Badge className={color}>{selectedStatus[index]}</Badge>;
  };
  const toggleDropdownStatus = (index) => {
    console.log(index);
    const updatedDropdownOpen = [...dropdownStatusOpen];
    updatedDropdownOpen[index] = !updatedDropdownOpen[index];
    setDropdownStatusOpen(updatedDropdownOpen);
  };

  const toggleDropdownFilteredStatus = () => {
   
console.log(offerStatusFilterOpen);
 setOfferStatusFilterOpen(!offerStatusFilterOpen);
  };

  const totalPages = Math.ceil(sortedData.length / itemsPerPage);
const maxVisiblePages = 3;
const visiblePages = Math.min(totalPages, maxVisiblePages);
const startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
const endPage = Math.min(startPage + visiblePages - 1, totalPages);

  return (
    <><div>
      {notification && (
        <div className={`notification ${notification.type}`}>
          {notification.message}
        </div>
      )}
    </div><Container className="mt-4">
        <Row>
          <Col>
            <Card>
              <CardHeader>
              <div className="d-flex justify-content-between align-items-center">
              <h5 class="font-weight-bolder">All Offers  
              </h5>
              <div className="tr-dropdown mb-3">
                              <Dropdown isOpen={offerStatusFilterOpen} toggle={() => toggleDropdownFilteredStatus()}>
                                <DropdownToggle caret className="custom-dropdown-toggle">
                                  {offerStatusFilter}
                                </DropdownToggle>
                                <DropdownMenu>
                                  {offerStatuses.map((status) => (
                                    <DropdownItem key={status.value} onClick={() => handleFilteredStatusChange(status.value)}>
                                      {status.label}
                                    </DropdownItem>
                                  ))}
                                   <DropdownItem key={"all"} onClick={() => handleFilteredStatusChange('all')}>
                                      All
                                    </DropdownItem>
                                </DropdownMenu>
                              </Dropdown>
                            </div>
                            </div>
              <div></div>
                <div className="d-flex justify-content-between align-items-center">

                  <div className="d-flex align-items-center">
                    <div className="mr-2 text-sm">Items per page:</div>
                    <Dropdown
                      isOpen={dropdownOpen}
                      toggle={() => setDropdownOpen(!dropdownOpen)}
               
                    >
                      <DropdownToggle caret className="btn btn-outline-primary btn-sm export mb-0 mt-sm-0 mt-1 p-1">{itemsPerPage}</DropdownToggle>
                      <DropdownMenu>
                        <DropdownItem onClick={handleItemsPerPageChange} value={10}  
                    
                        >
                          10
                        </DropdownItem>
                        <DropdownItem onClick={handleItemsPerPageChange} value={25}>
                          25
                        </DropdownItem>
                        <DropdownItem onClick={handleItemsPerPageChange} value={50}>
                          50
                        </DropdownItem>
                        {/* Add more options if needed */}
                      </DropdownMenu>
                    </Dropdown>
                  </div>
                  <div className="d-flex align-items-center">
                    <InputGroup className="col-md-12">
                      <Input
                        type="text"
                        placeholder="Search..."
                        value={searchValue}
                        onChange={handleSearchChange} />
                    </InputGroup>
                  </div>
                </div>
                <div className="card-body px-0 pb-2">
                  <div className="table-responsive" style={{ overflowX: 'none' }} >
                    <Table className="table-fixed-header">
                      <thead className="bg-gradient-dark text-light font-weight-bold rounded">
                        <tr>
                          <th>
                            <div
                              className="d-flex align-items-center"
                              onClick={() => handleSort("id")}
                            >
                              Id{" "}
                              {selectedSortColumn === "id" && (
                                <i
                                  className={`fas fa-sort-alpha-${sortDirection === "asc" ? "down" : "up"} ml-1`}
                                ></i>
                              )}
                            </div>
                          </th>
                          <th>
                            <div
                              className="d-flex align-items-center"
                              onClick={() => handleSort("offer_name")}
                            >
                              Offer Name{" "}
                              {selectedSortColumn === "offer_name" && (
                                <i
                                  className={`fas fa-sort-alpha-${sortDirection === "asc" ? "down" : "up"} ml-1`}
                                ></i>
                              )}
                            </div>
                          </th>
                          <th>User Coins</th>
                          <th>Revenue | Payout</th>
                          <th>Caps | Completed</th>
                          <th>Status</th>
                          <th>More</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentItems.map((item, index) => (

                          <React.Fragment key={item.id}>

                          <tr onClick={() => handleRowClick(item.id)} className={expandedRow === item.id ? 'expanded ' : ''} >

                          <td className="text-center text-bold font-weight-bold align-middle text-center text-sm">#{item.id}</td>

                          <td>
                            <div className="d-flex px-2 py-1 align-items-center">
                              <div>
                                <img
                                  src={item.offer_small_icon}
                                  alt="Profile"
                                  className="avatar avatar-sm me-3"
                                />
                              </div>
                              <div className="d-flex flex-column justify-content-center ">
                                <h6 className="mb-0 text-sm">{item.offer_name}</h6>
                                <p className="text-xs text-secondary mb-0">
                                  <span className="badge badge-sm bg-gradient-info">{item.advertiser}</span>
                                </p>
                              </div>
                            </div>
                          </td>

                          <td className="text-center align-middle text-center text-sm font-weight-bold">{item.offer_user_reward}</td>

                          <td className="text-center align-middle text-center text-sm font-weight-bold">
                            {item.offer_revenue} | {item.offer_payout}
                          </td>

                          <td className="text-center font-weight-bold align-middle text-center text-sm">
                            {item.offer_trackings[0].total_caps} | {item.offer_trackings[0].completed_caps != null ? item.offer_trackings[0].completed_caps : 0}
                          </td>

                          <td className="text-center font-weight-bold align-middle text-center text-sm">
                            <div>
                              <Dropdown isOpen={dropdownStatusOpen[index]} toggle={() => toggleDropdownStatus(index)}>
                                <DropdownToggle caret className="custom-dropdown-toggle">
                                  {renderBadge(index)}
                                </DropdownToggle>
                                <DropdownMenu>
                                  {offerStatuses.map((status) => (
                                    <DropdownItem key={status.value} onClick={() => handleStatusChange(status.value, index)}>
                                      {status.label}
                                    </DropdownItem>
                                  ))}
                                </DropdownMenu>
                              </Dropdown>
                            </div>
                          </td>

                          <td className="text-center font-weight-bold align-middle text-center text-sm">
                            <button className="btn btn-icon-only btn-rounded btn-outline-dark mb-0 me-2 btn-sm d-flex align-items-center justify-content-center">
                              <i className={`ni ${expandedRow === item.id ? 'ni-bold-up' : 'ni-bold-down'}`}
      aria-hidden="true"></i>
                            </button>
                            {/* Other action buttons */}
                          </td>

                          </tr>


                            {expandedRow === item.id && (
                              <tr className="expanded tr-card">
                                <td colSpan="7">
                                  <div classname="d-flex justify-content-between align-items-center ">
                                    <Link to={"/admin/campaign/edit/" + item.id} addonType="append" className="mr-2">
                                      <button type="button" className="btn btn-sm bg-gradient-primary">
                                        <FaPencil /> &nbsp;
                                        Edit
                                      </button>
                                    </Link>


                                    <button type="button" className="btn btn-sm bg-gradient-info">
                                      Analytics
                                    </button>

                                    <div></div>
                                  </div>

                                </td>
                                <Modal isOpen={isDeleteModalOpen} toggle={closeDeleteModal}>
                                  <ModalHeader toggle={closeDeleteModal}>Confirm Delete</ModalHeader>
                                  <ModalBody>Are you sure you want to delete this Offer Id: {item.id}</ModalBody>
                                  <ModalFooter>
                                    <Button color="secondary" onClick={closeDeleteModal}>Cancel</Button>
                                    <Button color="danger" onClick={handleDelete}>Delete</Button>
                                  </ModalFooter>
                                </Modal>

                              </tr>
                            )}

                          </React.Fragment>

                        ))}
                      </tbody>

                    </Table>
                </div>
              </div>
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  Showing {indexOfFirstItem + 1} to{" "}
                  {Math.min(indexOfLastItem, sortedData.length)} of{" "}
                  {sortedData.length} items
                </div>

                <div>
                  <nav aria-label="Page navigation example">
                    <ul className="pagination">
                      <li className={currentPage === 1 ? "page-item disabled" : "page-item"}>
                        <a
                          className="page-link"
                          href="javascript:;"
                          aria-label="Previous"
                          onClick={() => handlePageChange(currentPage - 1)}
                        >
                          <i className="fa fa-angle-left"></i>
                          <span className="sr-only">Previous</span>
                        </a>
                      </li>
                      {Array.from({ length: visiblePages }, (_, index) => (
                        <li
                          key={index}
                          className={currentPage === startPage + index ? "page-item active" : "page-item"}
                          onClick={() => handlePageChange(startPage + index)}
                        >
                          <a className="page-link" href="javascript:;">
                            {startPage + index}
                          </a>
                        </li>
                      ))}
                      <li
                        className="page-item"
                        disabled={currentPage === Math.ceil(sortedData.length / itemsPerPage)}
                        onClick={() => handlePageChange(currentPage + 1)}
                      >
                        <a className="page-link" href="javascript:;" aria-label="Next">
                          <i className="fa fa-angle-right"></i>
                          <span className="sr-only">Next</span>
                        </a>
                      </li>
                    </ul>

                  </nav>
                </div>

              </div>
            </CardHeader>
          </Card>
        </Col>
      </Row>
      </Container></>
    
  );
};

export default ViewCampaign;
